import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const BoxContainer = styled(Box)(({ theme }) => {
  const { space, layout } = theme.palette.tokens;
  return {
    margin: `${space[5]}px ${layout.contentGutter}px ${space[14]}px`,
  };
});

/* Left offset clears the progress-bar rail of the work order pages. */
export const SectionBox = styled(Box)(({ theme }) => ({
  margin: `0 0 ${theme.palette.tokens.space[5]}px 34px`,
}));

export const TitleBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: theme.palette.tokens.space[10],
  alignItems: 'center',
  '@media (max-height: 820px)': {
    marginBottom: theme.palette.tokens.space[8],
  },
  svg: {
    color: theme.palette.text.secondary,
  },
}));

export const FlexBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
}));

export const FlexBoxGap = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '32px',
}));

export const FlexSpaceBetweenBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

export const CancelOsBox = styled(Box)(() => ({
  display: 'flex',
}));

export const ButtonBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row-reverse',
}));

export const LoadingBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  margin: '160px 0',
}));

export const FlexReverseBox = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row-reverse',
}));
